import React, { memo } from 'react';

interface MascotAvatarProps {
  size?: number;
  className?: string;
}

const MascotAvatarComponent: React.FC<MascotAvatarProps> = ({ size = 64, className = '' }) => {
  return (
    <img
      src="/agent-3d.gif"
      alt="BongAI 助手"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: 'contain', display: 'block' }}
      draggable={false}
    />
  );
};

export const MascotAvatar = memo(MascotAvatarComponent);
